/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
/**
 * Provides all nessesary aria-* attributes to create valid disabled state for interactive components.
 */
export function ariaDisabled() {
    return (target) => target.addInitializer((instance) => new AriaDisabledController(instance));
}
export class AriaDisabledController {
    constructor(host) {
        this.host = host;
        this.host.addController(this);
    }
    hostUpdated() {
        if (this.host.disabled !== null) {
            this.host.ariaDisabled = this.host.disabled;
        }
        if (this.host.readonly) {
            this.host.ariaDisabled = null;
        }
    }
}
